import { render, staticRenderFns } from "./side-menu-item.vue?vue&type=template&id=0e2fe5b3"
import script from "./side-menu-item.ts?vue&type=script&lang=js&external"
export * from "./side-menu-item.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports